// const sharetribeSdk = require('sharetribe-flex-sdk');
// const sdk = sharetribeSdk.createInstance({
//   clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID,
// });

// require axios
//const axios = require('axios');
import axios from 'axios';


export const extendStateDataForGoogleAuth = (originalFunction) => {
    return (...args) => {
      const stateData = originalFunction(...args);
      
      if (stateData.processState === 'accepted' && args[0].transactionRole === 'provider') {
        return { ...stateData, showGoogleAuth: true };
      }
  
      return stateData;
    };
};

export const extendInitiateOrderForGoogleCalendar = (originalInitiateOrder) => {
    return (orderParams, processAlias, transactionId, transitionName, isPrivilegedTransition) => {
      return async (dispatch, getState, sdk) => {
        const response = await dispatch(
          originalInitiateOrder(orderParams, processAlias, transactionId, transitionName, isPrivilegedTransition)
        );
  
        if (response && response.data && response.data.data) {
          const { bookingStart, bookingEnd, listingId } = orderParams;
          const listing = await sdk.listings.show({ id: listingId });
          const providerId = response.data.data.relationships.provider.data.id.uuid;
  
           if (listing && providerId) {
                const googleCalendarEvent = {
                    start: bookingStart,
                    end: bookingEnd,
                    title: listing.data.data.attributes.title,
                    description: `Booking for listing: ${listingId.uuid}`,
                    userId: providerId,
                    timeZone: listing.data.data.attributes.availabilityPlan.timezone,
                };
           
                const postResponse = await post('/api/create-event', { googleCalendarEvent });
           }
        }
        return response;
      };
    };
};

export const createEventIfNotExists = async (userId, gapiClient, transactionId, sdk, listing) => {

    console.log('Creating event on Google Calendar...');

    const transaction = await sdk.transactions.show(
      {
        id: transactionId,
        include: ['booking']
      });

    //const booking = await sdk.bookings.show({
    //  id: transaction.data.data.relationships.booking.data.id});

    const today = new Date();
    const twoMonths = new Date(today);
    twoMonths.setMonth(today.getMonth() + 2);

    const bookings = await sdk.bookings.query({
      listingId: listing.id,
      start: today,
      end: twoMonths,
    });

    // get the booking from bookings with the id in transaction
    const booking = bookings.data.data.find(
      b => b.id.uuid === transaction.data.data.relationships.booking.data.id.uuid);


    const bookingStart = booking.attributes.start;
    const bookingEnd = booking.attributes.end;

    console.log('Booking start: ', bookingStart);
    console.log('Booking end: ', bookingEnd);

    const bookingStartISO = new Date(bookingStart).toISOString(); 
    const bookingEndISO = new Date(bookingEnd).toISOString();


    if (!gapiClient.calendar) {
      console.log("try to load calendar");
      await gapiClient.load("calendar", "v3");
    }

    // query with gapiClient the google calendar to see if I have events on booking start and end
    const events = await gapiClient.calendar.events.list({
      calendarId: 'primary',
      timeMin: bookingStartISO,
      timeMax: bookingEndISO,
      //timeZone: listing.attributes.availabilityPlan.timezone,
    });

    console.log('Events: ', events);

    // check if I have any event in events
    if (events.result.items.length > 0) {
      console.log('Event already exists');
      return;
    }

    const googleCalendarEvent = {
      start: bookingStart,
      end: bookingEnd,
      title: listing?.attributes.title,
      description: `Booking for listing: ${listing.id.uuid}`,
      userId: userId,
      timeZone: listing.attributes.availabilityPlan.timezone,
    };

    // Third API call, create event on mentor calendar IF he has the Google tokens saved
    try {
        const response = await axios.post('/api/create-event', { googleCalendarEvent });
        console.log('Google Calendar event created successfully:', response.data);
    } catch (error) {
        console.error('Error creating Google Calendar event:', error.response?.data || error.message);
    }

};

// module.exports = {
//     extendStateDataForGoogleAuth
// };